import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Product from "@/pages/Product";
import QuoteFunnel from "@/components/QuoteFunnel";
import Referral from "@/pages/Referral";
import Reviews from "@/pages/Reviews";
import Legal from "@/pages/Legal";
import Campaign from "@/pages/Campaign";
import Login from "@/crm/Login";
import CrmLayout from "@/crm/CrmLayout";
import Dashboard from "@/crm/Dashboard";
import Pipeline from "@/crm/Pipeline";
import Leads from "@/crm/Leads";
import LeadProfile from "@/crm/LeadProfile";
import Marketing from "@/crm/Marketing";
import Customers from "@/crm/Customers";
import Settings from "@/crm/Settings";

const PL = (el) => <PublicLayout>{el}</PublicLayout>;

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/crm/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <HelmetProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
        <Routes>
          <Route path="/" element={PL(<Home />)} />
          <Route path="/quote" element={PL(<QuoteFunnel />)} />
          <Route path="/refer" element={PL(<Referral />)} />
          <Route path="/reviews" element={PL(<Reviews />)} />
          <Route path="/privacy" element={PL(<Legal />)} />
          <Route path="/terms" element={PL(<Legal />)} />
          <Route path="/c/:slug" element={<Campaign />} />
          <Route path="/crm/login" element={<Login />} />
          <Route path="/crm" element={<Protected><CrmLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="pipeline" element={<Pipeline />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/:id" element={<LeadProfile />} />
            <Route path="marketing" element={<Marketing />} />
            <Route path="customers" element={<Customers />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path=":slug" element={PL(<Product />)} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </HelmetProvider>
    </AuthProvider>
  );
}

export default App;
